module.exports = __webpack_public_path__ + "media/images/writer/home/kv-bg-phone@3x-4fc8c8725b2159b701b7ca8a8836b320.png";